import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle, ModalTransition } from '@atlaskit/modal-dialog';
import { SpinnerMask } from '@atlassian/amkt-common';
import React, { useEffect } from 'react';
import { makeHostInfo } from '../../../records/HostInfo';
import { DialogState } from '../AppRequestDialog.types';
import { getDialogState } from '../utils/getDialogState';
import { AppRequestDialogFooter } from './AppRequestDialogFooter';
import AppRequestDialogHeader from './AppRequestDialogHeader';
import { AppRequestDialogModalInstalled } from './AppRequestDialogModalInstalled';
import { AppRequestDialogModalRejected } from './AppRequestDialogModalRejected';
import { AppRequestDialogModalRequested } from './AppRequestDialogModalRequested';
import { AppRequestDialogModalRequestable } from './AppRequestDialogRequestable/AppRequestDialogModalRequestable';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const resolveDialogContent = props => {
  const dialogType = getDialogState(props.appRequestBaseData);
  switch (dialogType) {
    case DialogState.REQUESTABLE:
      return /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(AppRequestDialogModalRequestable, {
          onClose: props.onClose,
          appKey: props.appKey,
          appName: props.appRequestBaseData.result.appDetails.name,
          flags: props.flags,
          onRequestSuccess: props.onRequestSuccess,
          onRequestFailure: props.onRequestFailure,
          hostInfo: makeHostInfo(props.hostInfo),
          fireEvent: props.fireEvent,
          links: props.links
        })
      });
    case DialogState.LOADING:
      return /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(SpinnerMask, {
          active: true,
          delay: 200,
          size: 50
        }), /*#__PURE__*/_jsx(ModalFooter, {})]
      });
    case DialogState.INSTALLED:
      return /*#__PURE__*/_jsx(AppRequestDialogModalInstalled, {});
    case DialogState.REJECTED:
      {
        var _result$appRequestSta;
        const {
          result
        } = props.appRequestBaseData;
        const rejectComment = (_result$appRequestSta = result.appRequestStatus) === null || _result$appRequestSta === void 0 ? void 0 : _result$appRequestSta.rejectComment;
        return /*#__PURE__*/_jsx(AppRequestDialogModalRejected, {
          rejectComment: rejectComment
        });
      }
    case DialogState.REQUESTED:
      return /*#__PURE__*/_jsx(AppRequestDialogModalRequested, {});
    default:
      return /*#__PURE__*/_jsx(ModalBody, {
        children: "Error"
      });
  }
};
export default function AppRequestDialogModal(props) {
  useEffect(() => {
    props.fireEvent.viewedAppRequestModalScreen();
  }, []);
  const dialogType = getDialogState(props.appRequestBaseData);
  const modalTitle = dialogType === DialogState.LOADING ? 'Loading...' : 'Request App';
  const showAppRequestDialogFooter = dialogType === DialogState.INSTALLED || dialogType === DialogState.REJECTED || dialogType === DialogState.REQUESTED;
  return /*#__PURE__*/_jsx(ModalTransition, {
    children: /*#__PURE__*/_jsxs(Modal, {
      width: "large",
      onClose: props.onClose,
      children: [/*#__PURE__*/_jsx(ModalHeader, {
        children: /*#__PURE__*/_jsx(ModalTitle, {
          children: modalTitle
        })
      }), /*#__PURE__*/_jsxs(ModalBody, {
        children: [/*#__PURE__*/_jsx(AppRequestDialogHeader, {
          baseDataResult: props.appRequestBaseData.result,
          appDetailsFromSearchResponse: props.appDetailsFromSearchResponse,
          links: props.links,
          config: props.config,
          appKey: props.appKey,
          dialogType: dialogType
        }), resolveDialogContent(props), showAppRequestDialogFooter && /*#__PURE__*/_jsx(AppRequestDialogFooter, {
          onClose: props.onClose,
          links: props.links,
          appKey: props.appKey
        })]
      })]
    })
  });
}